// extracted by mini-css-extract-plugin
export default {"dashboardContainer":"userManagement_dashboardContainer__VH703","MuiGrid-item":"userManagement_MuiGrid-item__OQeK8","MuiPaper-root":"userManagement_MuiPaper-root__b5Trd"};